import { useState, useEffect } from "react";
import {
  intl,
  getCurrentLocale,
  setLocale,
  SUPPORTED_LOCALES,
  type Locale,
} from "@/lib/i18n";

export function useLocale() {
  const [currentLocale, setCurrentLocale] =
    useState<Locale>(getCurrentLocale());

  useEffect(() => {
    // 初始化时设置语言
    const savedLocale = getCurrentLocale();
    setCurrentLocale(savedLocale);
  }, []);

  const changeLocale = (locale: Locale) => {
    setLocale(locale);
    setCurrentLocale(locale);
    // 刷新页面以应用新语言
    window.location.reload();
  };

  return {
    currentLocale,
    changeLocale,
    supportedLocales: SUPPORTED_LOCALES,
    t: intl.get.bind(intl),
  };
}
